import React from 'react'
import { useLocation } from 'react-router-dom'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, InputBase, Paper } from '@mui/material'
import { useGlobalState } from 'state'
import * as api from 'common/api'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'


export const SaveButton = () => {
  const state = useGlobalState()
  const location = useLocation()
  const [dialog, setDialog] = React.useState(false)
  const [scoreId, setscoreId] = React.useState('')
  const targetUrl = React.useMemo(() => window.location.origin + `/sheet/${scoreId}`, [scoreId])

  React.useEffect(() => {
    //
  }, [])

  const save = async () => {
    const params = {
      page: location.pathname,
      answers: state.app.answers
    }
    const res = await api.post('/scoresheet', params)
    if (res && res.id) {
      setscoreId(res.id)
      setDialog(true)
    }
  }

  const copyToClipboard = () => {
    navigator.clipboard.writeText(targetUrl)
  }

  return (
    <>
      <Button
        variant='contained'
        color='primary'
        size='small'
        sx={{width: 120}}
        onClick={save}
      >
        {'途中経過を保存'}
      </Button>
      <Dialog
        open={dialog}
        onClose={() => setDialog(false)}
      >
        <DialogTitle>
          {'途中経過を一時保存しました'}
        </DialogTitle>
        <DialogContent>
          <DialogContentText variant='body2' mb={2}>
            以下のURLからスコアリングシートを再開できます。
          </DialogContentText>
          <Paper
            component="form"
            sx={{ px: 1, display: 'flex', alignItems: 'center', width: 520 }}
          >
            <InputBase sx={{ m: 1, flex: 1 }} value={targetUrl} readOnly />
            <Button size='medium' variant="text" color='primary' startIcon={<ContentCopyIcon />} onClick={copyToClipboard}>
              コピー
            </Button>
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialog(false)} color='inherit'>閉じる</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
